import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MAINTENANCE_MODE_STATUSCODE } from 'constants/shared-constants';
import { Observable, catchError, throwError } from 'rxjs';
import { MaintenanceWorkFacade } from './maintenance-work.facade';

export const maintenanceWorkInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const maintenanceWorkFacade = inject(MaintenanceWorkFacade);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const { error: msg, status } = error;
        if (status === MAINTENANCE_MODE_STATUSCODE) {
          maintenanceWorkFacade.setMaintenanceWorkStatus(true, msg);
        } else if (maintenanceWorkFacade.maintenanceActive) {
          maintenanceWorkFacade.setMaintenanceWorkStatus(false, undefined);
        }
      }
      return throwError(() => error);
    }),
  );
};
